import { render, staticRenderFns } from "./selectTextReadingComprehension.vue?vue&type=template&id=0ce36892&scoped=true"
import script from "./selectTextReadingComprehension.vue?vue&type=script&lang=js"
export * from "./selectTextReadingComprehension.vue?vue&type=script&lang=js"
import style0 from "./selectTextReadingComprehension.vue?vue&type=style&index=0&id=0ce36892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce36892",
  null
  
)

export default component.exports